import { jsx as _jsx } from "react/jsx-runtime";
import { TextPreview } from '../text';
import { Attribution } from './Attribution';
export const MapAttributionPreview = (props) => {
    return (_jsx(Attribution, { children: _jsx(TextPreview, { ...props }) }));
};
//# sourceMappingURL=preview.js.map